(function() {
    $('#summernote').summernote({
        callbacks: {
            onImageUpload: function(files, editor, welEditable) {
                    sendFile(files[0], editor, welEditable);
            }
        }
    });
    function sendFile(file, editor, welEditable) {
            data = new FormData();
            data.append("file", file);
            $.ajax({
                data: data,
                type: "POST",
                url: "/" + franchiseSlug + "/events/upload",
                cache: false,
                contentType: false,
                processData: false,
                success: function(url) {
                    var image = $('<img>').attr('src', '//' + url);
                    $('#summernote').summernote("insertNode", image[0]);
                }
            });
        }
})()
